import styled from 'styled-components';
import rem from 'polished/lib/helpers/rem';
import toColorString from 'polished/lib/color/toColorString';
import color from '@decisiv/design-tokens/lib/color';
import spacing from '@decisiv/design-tokens/lib/spacing';
import Flex from '@decisiv/ui-components/lib/components/Flex';

// The trace IDs are long and must not wrap mid-id.
export const NoWrapRow = styled(Flex).attrs({
  marginTop: 2,
  flexDirection: 'row',
  justifyContent: 'space-between',
})`
  width: 100%;
  white-space: nowrap;
`;

export const MetaRow = styled(Flex).attrs({
  marginTop: 2,
  flexDirection: 'row',
  justifyContent: 'space-between',
})`
  width: 100%;
`;

export const InfoPanel = styled(Flex).attrs({
  flexDirection: 'column',
  marginTop: 2,
})`
  white-space: nowrap;
  border: ${rem(spacing.base * 0.1)} solid ${toColorString(color.base.halfMoon)};
  padding: ${rem(spacing.base)};
`;

// KDS ghost buttons sit slightly high next to a line of text.
export const InlineIconButton = styled.span`
  button {
    padding-bottom: ${rem(spacing.base * 0.5)};
    padding-left: ${rem(spacing.base * 0.5)};
  }
`;
